import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { ReleaseTestDocumentTableFilterSchema } from './-zod-schema';

// テストスイート詳細 > ドキュメントタブ。
// URL search のスキーマだけここで定義し、コンポーネントは index.lazy.tsx 側で
// 遅延ロードして bundle 分割する。
export const Route = createFileRoute(
  '/_stacktrace/test-suites/$id/_layout/document/',
)({
  validateSearch: zodValidator(ReleaseTestDocumentTableFilterSchema),
});
